<template>
  <div class="content if-profile manual_input">
    <div class="md-layout ratios-report">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div class="manege-input-popap">
          <MRReportHeader :headerData="this.headerData" />
        </div>
        <div class="md-toolbar-row">
          <nav-tabs-card>
            <template slot="content">
              <h1 class="section_header m-0 p-0">Manage Inputs</h1>
              <div v-if="!isSample" class="md-layout-item md-size-100 p-0">
                <md-card class="if_card">
                  <md-card-header class="md-card-header-icon"
                    >Data Input Upload</md-card-header
                  >
                  <md-card-content>
                    <div class="extra_space">
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 p-0"
                        >
                          <!-- <h3>Data Input Upload</h3> -->
                          <ul>
                            <li>
                              Download the Bizminer Industry Financial Input
                              5-year Templateand save it offline as a CSV file.
                            </li>
                            <li>Populate the template offline</li>
                            <li>
                              Select the Choose File or Browse button to find
                              the populated CSV file on your device.
                            </li>
                            <li>
                              Use the Upload Inputs button to complete the
                              process.
                            </li>
                            <li>
                              Generate the report. Your financials will be
                              integrated; percentages, summary line items and
                              ratios will auto-calculate.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <upload-my-data></upload-my-data>
                        </div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout">
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 py-4"
                >
                  <h5 class="m-0">
                    <strong
                      >*Please do not use periods, dollar signs, or character,
                      Commas are auromatically added.</strong
                    >
                  </h5>
                  <h5 class="m-0">
                    <strong>
                      *Business Revenue and Gross Margin are required fields
                    </strong>
                  </h5>
                </div>
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-2"
                >
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-content>
                        <md-table class="profit-and-loss-table">
                          <md-table-row>
                            <md-table-head>Types</md-table-head>
                            <md-table-head v-for="key in years" :key="key">{{
                              key
                            }}</md-table-head>
                          </md-table-row>
                          <md-table-row
                            v-for="(field, key) in inputFieldFiltered"
                            :key="key"
                          >
                            <md-table-cell :md-label="field.title">{{
                              field.title
                            }}</md-table-cell>
                            <md-table-cell
                              v-for="(each, index) in field.input"
                              :key="index"
                            >
                              <input
                                v-model="
                                  inputFieldFiltered[key]['input'][index]
                                "
                                @input="
                                  (e) =>
                                    handleInput(
                                      e,
                                      inputFieldFiltered[key]['input'][index],
                                      index
                                    )
                                "
                              />
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </md-card-content>
                    </div>
                  </div>
                  <div
                    v-if="!isSample"
                    class="md-layout-item md-size-100 p-0 btn_wpr"
                  >
                    <button
                      type="button"
                      @click="saveReport('clear')"
                      class="md-button md-info md-theme-default button-inputs"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">Clear Inputs</div>
                      </div>
                    </button>
                    <button
                      type="button"
                      @click="saveReport()"
                      class="md-button md-info md-theme-default"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          Submit Manual Inputs
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavTabsCard } from "@/components";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import MRReportHeader from "./_partials/MRReportHeader.vue";
import UploadMyData from "@/components/UploadMyData.vue";
export default {
  components: {
    NavTabsCard,
    MRReportHeader,
    UploadMyData,
  },
  props: ["headerData"],
  data() {
    return {
      showDialog: false,
      single: null,
      params: {},
    };
  },
  computed: {
    ...mapState({
      inputFields: (state) => state.user.market_report.data.inputFields,
      inputTypes: (state) => state.user.market_report.data.inputTypes,
      //inputData: (state) => state.user.market_report.data.data,
      //data: (state) => state.user.market_report.data.data,
      years: (state) => state.user.market_report.data.years,
    }),
    inputFieldFiltered() {
      var inputFieldFiltered = [];
      for (let key in this.inputTypes) {
        var arrayAux = {
          title: this.inputTypes[key],
          input: this.getCurrentType(key.split("_")[0]),
        };
        inputFieldFiltered.push(arrayAux);
      }
      return inputFieldFiltered;
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },

  methods: {
    ...mapActions({
      save: "user/saveReport",
      getReport: "user/getReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    handleInput(e, key, index) {
      //this.params[key + '_field_' + index] = Number(e.target.value);
    },
    saveReport(action = "save") {
      this.loading = true;
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      var paramsData = [];
      if (action === "save") {
        for (let key in this.inputFieldFiltered) {
          for (let subKey in this.inputFieldFiltered[key]["input"]) {
            paramsData[subKey] = this.inputFieldFiltered[key]["input"][subKey];
          }
        }
        paramsData = Object.assign({}, paramsData);
      }
      if (action === "clear") {
        for (let key in this.inputFields) {
          this.inputFields[key] = "";
        }
      }
      var formattedParams = [];
      var auxYears = this.years.map((item) => {
        return item.split(" ")[0];
      });
      Object.keys(paramsData).forEach((key) => {
        if (key.split("_").length > 2)
          formattedParams[
            key.split("_")[0] +
              "_" +
              key.split("_")[1] +
              "_" +
              auxYears.indexOf(key.split("_")[key.split("_").length - 1])
          ] = paramsData[key];
        else
          formattedParams[
            key.split("_")[0] +
              "_" +
              auxYears.indexOf(key.split("_")[key.split("_").length - 1])
          ] = paramsData[key];
      });
      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "imr",
        action: action,
        data: Object.assign({}, formattedParams),
      })
        .then((res) => {
          this.alertSuccess("Data loaded.");
          this.$router.push({
            name: "MRAboutTheData",
            params: this.$route.params.id,
          });
          this.$router.go();
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
    getCurrentType(keyAux) {
      return Object.keys(this.inputFields)
        .filter((key) => key.includes(keyAux))
        .reduce((cur, key) => {
          return Object.assign(cur, { [key]: this.inputFields[key] });
        }, {});
    },
  },
};
</script>
<style lang="scss">
.ratios-report {
  .grey {
    background-color: #c1c1c1;
  }
  .md-table-black-side-label {
    .md-table-head-label {
      color: black !important;
    }
  }
  .md-table-side-label {
    .md-table-head-label {
      color: #3b7ef1 !important;
    }
  }
  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }
  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }
    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }
  .heder-titel-col-2 {
    margin-bottom: 35px;
  }
  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }
    h4 {
      margin-left: 60px;
    }
  }
  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }
    .w-100 {
      width: 100%;
    }
  }
  .choose-files-box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    p {
      margin: 0;
      margin-left: 10px;
    }
    .md-icon {
      display: none !important;
    }
    .choose-file {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;
      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 11px;
      }
      input {
        margin: 0;
      }
    }
    .upload-file {
      background-color: #3b7ef1;
      label {
        color: white;
        top: 11px;
      }
    }
    .md-field:not(.md-disabled):after {
      background-color: transparent;
    }
  }
  .icon-arrow {
    transform: rotate(180deg) !important;
  }
  .md-table-cell {
    .md-table-cell-container {
      input {
        background-color: transparent !important;
        border: 1px solid #ddd;
        width: 60px;
        &.error-input {
          background-color: #ffbbbb !important;
        }
      }
    }
  }
  .md-collapse-content {
    padding: 0 !important;
  }
  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
  .manag-title {
    h1 {
      margin: 0;
    }
  }
  .manege-input-popap {
    display: flex;
    justify-content: flex-end;
  }
}
.button-inputs {
  margin-right: 10px !important;
}
</style>
